export function steps (state) {
  return state?.onboardings?.data || null
}
export function isLoading (state) {
  return state.onboardings?.fetching && !state.onboardings?.fetched
}
